"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import "@/app/auto-verkaufen/AutoVerkaufen.css";
import "@/common/Common.css";
import "../KaputtesAuto.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "@/app/auto-verkaufen/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";
import AutoVerkaufenApp from "@/assets/kaputtes-auto-verkaufen/wann-gilt-ein-fahrzeug-als-unfallauto.avif";
import bannerImage2 from "@/assets/kaputtes-auto-verkaufen/bannerImage2.webp";
import höchstenPreis from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-verkauf.avif";
import { fragenUnfallAuto } from "./data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";

const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function UnfallAutoVerkaufen() {
  const [step, setStep] = useState(1);

  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title={<>Unfallauto verkaufen – schnell, fair & einfach</>}
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br className="desktop" />
            Verkaufe dein Unfallauto und erhalte mehr Geld.
          </>
        }
        customNav="Kaputtes Auto"
        customNavLink="/kaputtes-auto-verkaufen"
        linkname="Unfallauto"
        link="/kaputtes-auto-verkaufen/unfallauto-verkaufen"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/kaputtes-auto-verkaufen/unfallauto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Wie verkaufe ich am besten einen Unfallwagen?"
              leftText={
                <>
                  <p>
                    Ein Unfall mit dem eigenen Auto ist oft ein Schock. Neben
                    dem Schaden am Fahrzeug kommen hohe Reparaturkosten,
                    Wertverlust und die Unsicherheit dazu, ob sich eine
                    Reparatur überhaupt lohnt. Genau hier stellt sich die
                    entscheidende Frage: Solltest Du Dein Unfallauto reparieren
                    oder lieber verkaufen?
                  </p>
                  <p>
                    Bei Autoeinfachlos bieten wir Dir eine einfache, schnelle
                    und transparente Lösung: Dein Unfallauto verkaufen,
                    unkompliziert und zu einem fairen Preis über unser Netzwerk
                    mit mehr als 5.000 geprüften Händlern.
                  </p>
                </>
              }
              rightFirstTitle="Unfallauto – was bedeutet das für den Autoverkauf?"
              rightFirstText={
                <>
                  <p>
                    Als Unfallauto gilt jedes Fahrzeug, das durch einen
                    Zusammenstoß oder eine Beschädigung einen Schaden erlitten
                    hat. Das kann ein leichter Blechschaden sein, aber auch ein
                    schwerer Totalschaden.
                  </p>

                  <p>
                    <strong>Wichtig für den Verkauf:</strong>
                  </p>
                  <ul className="custom-unordered-list ">
                    <li>
                      Bereits kleine Schäden können den Wiederverkaufswert
                      erheblich mindern.
                    </li>
                    <li>
                      Bei größeren Unfällen steigen Reparaturkosten schnell über
                      den aktuellen Fahrzeugwert hinaus.
                    </li>
                    <li>
                      Käufer sind oft skeptisch, wenn es um die Unfallhistorie
                      geht.
                    </li>
                  </ul>

                  <p>
                    Gerade deshalb ist es sinnvoll, den Verkauf des Unfallautos
                    über eine professionelle Plattform wie Autoeinfachlos
                    abzuwickeln.
                  </p>
                </>
              }
              rightSecondTitle="Unfallauto verkaufen statt reparieren: warum es sich lohnt"
              rightSecondText={
                <>
                  <p>
                    Eine Reparatur klingt im ersten Moment naheliegend, ist aber
                    oft keine wirtschaftlich sinnvolle Entscheidung.
                  </p>

                  <p>
                    <strong>Die Gründe:</strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Hohe Kosten:</strong> Ersatzteile und
                      Werkstattstunden summieren sich schnell.
                    </li>
                    <li>
                      <strong>Wertverlust bleibt:</strong> Selbst nach Reparatur
                      gilt Dein Wagen weiterhin als Unfallwagen.
                    </li>
                    <li>
                      <strong>Zeitaufwand:</strong> Termine in der Werkstatt,
                      Ersatzwagen, Versicherungsabwicklung.
                    </li>
                  </ul>

                  <p>Wenn Du Dein Unfallauto verkaufst, erhältst Du:</p>
                  <ul className="custom-unordered-list secondary">
                    <li>Sofortigen Verkaufserlös ohne Zusatzkosten.</li>
                    <li>Sicherheit, dass keine Folgeschäden auftreten.</li>
                    <li>Zeitersparnis durch einen unkomplizierten Prozess.</li>
                  </ul>

                  <h3>Wer kauft Unfallautos?</h3>
                  <p>
                    Viele Privatkäufer meiden Unfallautos, da sie
                    Reparaturrisiken fürchten. Anders ist es bei professionellen
                    Händlern. Diese kaufen Unfallwagen gezielt an, um sie
                    weiterzuverkaufen oder als Ersatzteilspender zu nutzen.
                  </p>

                  <p>
                    <strong>
                      Vorteile des Händlernetzwerks von Autoeinfachlos:
                    </strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      Über 5.000 registrierte Händler bieten auf Dein Fahrzeug.
                    </li>
                    <li>Wettbewerb sichert Dir den besten Preis.</li>
                    <li>
                      Seriöse, geprüfte Partner garantieren einen sicheren
                      Ablauf.
                    </li>
                  </ul>

                  <p>
                    Damit erzielst Du beim Unfallwagen verkaufen oft deutlich
                    bessere Preise als im Privatverkauf.
                  </p>

                  <p>
                    Wie die Abmeldung Deines Fahrzeugs abläuft und welche
                    Unterlagen Du dafür brauchst, erklärt unser Guide:
                  </p>
                  <p>
                    👉{" "}
                    <Link className="link" href="/guides/auto-abmelden">
                      Auto abmelden in Österreich
                    </Link>
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={AutoVerkaufenApp}
                h2
                isBig
                fontSize="36px"
                title="Was ist mein Unfallauto noch wert?"
                alt="Was ist mein Unfallauto noch wert"
                text={
                  <>
                    <p>
                      Der Restwert eines Unfallwagens hängt von mehreren
                      Faktoren ab:
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Alter und Laufleistung</li>
                      <li>Marke und Modell</li>
                      <li>Art und Umfang des Schadens</li>
                      <li>Kosten für mögliche Reparaturen</li>
                    </ul>

                    <p>
                      Die gute Nachricht: Bei Autoeinfachlos erhältst Du eine
                      kostenfreie Fahrzeugbewertung. So weißt Du in wenigen
                      Minuten, welchen Wert Dein Unfallauto aktuell noch hat.
                      Unverbindlich und ohne Risiko.
                    </p>
                    <p>
                      👉{" "}
                      <Link className="link" href="/auto-bewerten">
                        Jetzt Auto bewerten
                      </Link>
                    </p>
                  </>
                }
              />

              <BildTextInfo
                image={bannerImage2}
                h2
                isBig
                fontSize="36px"
                title="Ablauf: So verkaufst Du Dein Unfallauto über Autoeinfachlos"
                alt="Ablauf beim Verkauf eines Unfallautos"
                text={
                  <>
                    <p>
                      Der Verkauf Deines Unfallwagens ist einfacher, als Du
                      denkst. So funktioniert es:
                    </p>
                    <ol className="custom-ordered-list">
                      <li>
                        <strong>Fahrzeug online bewerten lassen</strong> – gib
                        Deine Daten ein und erhalte sofort eine erste
                        Einschätzung.
                      </li>
                      <li>
                        <strong>24-Stunden-Auktion starten</strong> – Dein
                        Unfallauto wird unserem Händlernetzwerk präsentiert.
                      </li>
                      <li>
                        <strong>Bestes Angebot erhalten</strong> – innerhalb
                        eines Tages liegen Dir verbindliche Gebote vor.
                      </li>
                      <li>
                        <strong>Abholung & sichere Zahlung</strong> – Dein Auto
                        wird bei Dir abgeholt, die Bezahlung erfolgt zuverlässig
                        und schnell.
                      </li>
                    </ol>

                    <p>
                      So sparst Du Dir Verhandlungen, Unsicherheit und unnötige
                      Zeitverluste.
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufige Fragen rund um den Verkauf von Unfallautos"
              fragen={fragenUnfallAuto}
              image={FAQImage}
              removePaddingBottom
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Unfallauto verkaufen"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Dein Unfallauto verkaufen - einfach, sicher und fair"
                alt="Unfallauto verkaufen mit Autoeinfachlos"
                text={
                  <>
                    <p>
                      Ein Unfallauto zu reparieren lohnt sich oft nicht. Über
                      Autoeinfachlos kannst Du Dein Unfallauto verkaufen –
                      unkompliziert, schnell und zu einem marktgerechten Preis.
                      Unser Netzwerk aus 5.000 Händlern sorgt dafür, dass Du das
                      beste Angebot erhältst, ohne selbst aufwendig nach Käufern
                      suchen zu müssen.
                    </p>
                    <p>
                      👉{" "}
                      <Link className="link" href="/auto-bewerten">
                        Jetzt Unfallauto kostenlos bewerten & Angebot erhalten
                      </Link>
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-bewerten"
            title="Jetzt Unfallauto kostenlos bewerten"
            h2
          />
        </div>
      )}
    </div>
  );
}

export default UnfallAutoVerkaufen;
